export default {
  filters: {
    displayCoordinates (coordinates) {
      if (!coordinates || !coordinates.length) return ''
      const latLng = coordinates.slice(0, 2)
      return [latLng[1], latLng[0]].map(c => c.toFixed(5)).join(', ')
    }
  }
}
